<template>
    <div class="docs-list" id="section-8" style="display: none">
        <h1>Deployment Tool</h1>

        <hr/>

        <pre><code>The Deployment Tool is a mobile App helping developer to finish the deployment. Only iPhone version is available at this moment.
</code></pre>

        <h3>I. Setup configurations</h3>

        <p>In the deployment process, you may need to setup a unified UUID, transmitter power, broadcasting interval and
            password. Input a new value to the configuration that need to be modified and leave the rest as
            "unchanged".</p>

        <p style="text-align:center">
            <img src="/static/image/developer/develop/1.jpg" height="783" width="270" alt=""/>
        </p>

        <h3>II. Add Yunzi to configuration device list</h3>

        <p>Select devices that need to be configured.</p>

        <p><strong>Two options are provided:</strong></p>

        <ol>
            <li>
                <p>Add device through scanning the QR code</p>

                <p style="text-align:center">
                    <img src="/static/image/developer/develop/2.png" height="480" width="270" alt=""/>
                </p>
            </li>
            <li>
                <p>Add through ranging active BLE device</p>

                <p style="text-align:center">
                    <img src="/static/image/developer/develop/3.png" height="480" width="270" alt=""/>
                </p>
            </li>
        </ol>

        <h3>III. Start configuration</h3>

        <p>Completing all the devices' configuration prcess within certain region, you may step to the next spot to
            configure other devices which are not in your previous range.</p>

        <p><strong>Configuration status:</strong></p>

        <ol>
            <li>Default: While circle</li>
            <li>Start configuration: Yellow</li>
            <li>Succeeded: Green</li>
            <li>Invalid password: Purple</li>
            <li>Connection failed: Red</li>
            <li>
                <p>Not in range: Grey</p>
                <p style="text-align:center">
                    <img src="/static/image/developer/develop/4.png" height="480" width="270" alt=""/>
                    <img src="/static/image/developer/develop/5.png" height="480" width="270" alt=""/>
                </p>
            </li>
        </ol>
        <div class="download-app first">
            <a class="ios-download"
               href="https://itunes.apple.com/cn/app/sensoro-bu-shu-gong-ju/id1061844253?mt=8"
               style="margin-right:20px;">
                iOS Deployment Tool
            </a>
        </div>
        <div class="download-app">
                        <span style="display: block; margin-bottom: 10px;">
                            Download more Apps
                        </span>
            <img id="qrcode" src="/static/image/docs/qrcode.png" width="115px"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "develop"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/docs/develop.vue